import React from "react";
import ForgotPassword from "../Auth/forgot";
import { Link } from "react-router-dom";

const ForgotPage = () => {
  return (
    <div style={{ width: "100%" }}>
      <div className="t-title">
        <h1>Recuperar contraseña</h1>
      </div>
      <div className="main">
        <ForgotPassword />
        <br />
        <Link className="button button-secondary" to="/login">
          Volver al login
        </Link>
      </div>
    </div>
  );
};

export default ForgotPage;
